import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { Heading } from '../typography/heading';
import { Text } from '../typography/text';
import { emptyStateVariants } from './empty-state.variants';

export interface EmptyStateProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'>,
    VariantProps<typeof emptyStateVariants> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, size, icon, title, description, action, ...props }, ref) => (
    <div ref={ref} className={cn(emptyStateVariants({ size }), className)} {...props}>
      {icon && (
        <div className="rounded-tk-full bg-[var(--tk-surface-bg-elevated)] p-4 text-[var(--tk-surface-fg-muted)] mb-1">
          {icon}
        </div>
      )}
      <Heading size={size === 'lg' ? 'h3' : size === 'sm' ? 'h5' : 'h4'} as={3}>
        {title}
      </Heading>
      {description && (
        <Text size={size === 'sm' ? 'sm' : 'md'} color="muted">
          {description}
        </Text>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  ),
);

EmptyState.displayName = 'EmptyState';
